// src/components/GroupSettings.tsx
import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useSocket } from "../context/SocketProvider";

import * as GroupStyle from "../styles/GroupSettings.style";
import * as DeviceStyle from "../styles/DeviceSettings.style";
import '../styles/DeviceInfo.css';
import { MediaQuery } from 'react-responsive';

import { Button, Popover } from 'antd';


//const SOCKET_URL = "http://172.16.20.112:3000"; // socket.io 서버
const SOCKET_URL = "https://rek-hybrid.co.kr"; // socket.io 서버

interface UserData {
    role: string;
    // 필요한 다른 속성들...
}



interface Device {
  [k: string]: any;
}

/**********************************/

interface Props {
    currentUser: UserData | null;
    // 디바이스 정보
    devices: Device[];

    selectedGroupId: number | null;
    selectedSiteId: number | null;
    selectedGroupName: string | null;
}



const GroupStatus: React.FC<Props> = ({
    currentUser,
    devices,

    selectedGroupId,
    selectedSiteId,
    selectedGroupName,

}) => {

    const socket = useSocket();

    const [devicesDB, setDevicesDB] = useState< any[]>([]);

    const fetchDeviceSetInfo = async () => {
        if (!selectedSiteId || !selectedGroupId) return;
        try {
            const response = await axios.get(`${SOCKET_URL}/api/device/setinfo`, {
            params: { selectedSiteId, selectedGroupId },
            });

            if(response.data === null || response.data === '')
            {
                console.log('[DEBUG] React: 조회 값 없음');
            }
            else
            {
                //console.log('[DEBUG] React: 조회 응답', response.data);
                setDevicesDB(response.data.data);
            }
        } catch (error) {
            console.error('[DEBUG] React: API 호출 실패', error);
        }
    }; 

    
    // ***************************************************************************
    //    DB 설정 값으로 초기화, 저장 적용 테스트
    // ***************************************************************************
    let initDistanceLeft=0;
    let initDistanceRight=0;
    let initDistanceBottom=0;

    let initLedmode=0;
    let initMinBright=0;
    let initMaxBright=0;
    let initKeepOnTime=0;
    let initSideOnLed=0;
    // fetchDeviceSetInfo();
    // console.log("fetch setinfo ==> ",devicesDB[0].LDistS);

    // 💡 핵심: Prop으로 받은 초기값을 내부 상태의 초기값으로 설정
    // if (!devices || devices.length === 0)
    if (!devicesDB)    
    {

    }
    else
    {
        // initDistanceLeft = devicesDB[0].LDistS; //LDistS
        // initDistanceRight = devicesDB[0].RDistS; //RDistS
        // initDistanceBottom = devicesDB[0].DDistS; //DDistS

        // initLedmode = devicesDB[0].led_mode;
        // initMinBright = devicesDB[0].minLED;
        // initMaxBright = devicesDB[0].maxLED;
        // initKeepOnTime = devicesDB[0].LEDOnT;
        // initSideOnLed = devicesDB[0].sLEDN;
    }
    const [currentDistanceLeft, setCurrentDistanceLeft] = useState(initDistanceLeft);
    const [currentDistanceRight, setCurrentDistanceRight] = useState(initDistanceRight);
    const [currentDistanceBottom, setCurrentDistanceBottom] = useState(initDistanceBottom);

    const [currentLedmode, setCurrentLedmode] = useState(initLedmode);
    const [currentMinBright, setCurrentMinBright] = useState(initMinBright);
    const [currentMaxBright, setCurrentMaxBright] = useState(initMaxBright);
    const [currentKeepOnTime, setCurrentKeepOnTime] = useState(initKeepOnTime);
    const [currentSideOnLed, setCurrentSideOnLed] = useState(initSideOnLed);

    // 2. 탭 진입 시 (groupSettingTab이 변경될 때) 데이터 로드 (추가/수정)
    useEffect(() => {
        // 예를 들어, 해당 설정 탭이 '1'번 탭이라고 가정합니다.
        // if (groupSettingTab === 1) { // 특정 탭에 한정하고 싶다면 이 조건문을 사용합니다.
            fetchDeviceSetInfo();
        // }
    // 탭 상태와 API 호출에 필요한 의존성을 포함합니다.
    }, [selectedSiteId, selectedGroupId]);

    // 3. devicesDB 데이터가 로드되면 개별 상태 변수 초기화 (추가)
    useEffect(() => {
        if (devicesDB && devicesDB.length > 0) {
            const initialData = devicesDB[0]; // 배열의 첫 번째 장치 객체 (단일 설정 객체)

            // DB에서 가져온 값으로 개별 상태 변수를 초기화합니다.
            // 데이터가 undefined인 경우를 대비해 기본값( || 0)을 넣어주는 것이 좋습니다.
            setCurrentLedmode(initialData.led_mode ?? 0);
            setCurrentMaxBright(initialData.maxLED ?? 0);
            setCurrentMinBright(initialData.minLED ?? 0);
            setCurrentKeepOnTime(initialData.LEDOnT ?? 0);
            setCurrentSideOnLed(initialData.sLEDN ?? 0);
            setCurrentDistanceLeft(initialData.LDistS ?? [0, 0]);
            setCurrentDistanceRight(initialData.RDistS ?? [0, 0]);
            setCurrentDistanceBottom(initialData.DDistS ?? [0, 0]);

            //console.log('[DEBUG] React: 개별 상태 변수 초기화 완료', initialData);
        }
    }, [devicesDB]); // devicesDB가 변경될 때마다 실행


    // ***************************************************************************
    // ***************************************************************************
    // ***************************************************************************


    // ***************************************************************************
    // ***************************************************************************
    // ***************************************************************************   
  
    return (
        <>
        <MediaQuery maxWidth={767}>  
            <DeviceStyle.MainContainer>
            <>
            <div className="dashboard-mobile-container">
                <center className="group-status">디바이스 목록 및 상태</center>

                {devices.map((device, fullIndex) => {
                    const deviceNum = fullIndex + 1;
                    const errorCode = Number(device.errSts);
                    const errorStatusText = Number(device.errSts) > 0 ? '에러 발생' : '정상 작동';
                    const errorStatusClass = Number(device.errSts) > 0 ? 'status-error' : 'status-ok';
                    let popoverContent; 

                    if (errorCode === 1) {
                        popoverContent = (
                            <div>
                                <p>🚨 통신 오류</p>
                            </div>
                        );
                    } else if (errorCode === 2) {
                        popoverContent = (
                            <div>
                                <p>🚨 LED 조명 불량</p>
                            </div>
                        );
                    } else if (errorCode === 3) {
                        popoverContent = (
                            <div>
                                <p>🚨 가로등 기울기 불량</p>
                            </div>
                        );
                    } else if (errorCode === 4) {
                        popoverContent = (
                            <div>
                                <p>🚨 풍력 발정기 불량</p>
                            </div>
                        );
                    } else if (errorCode === 5) {
                        popoverContent = (
                            <div>
                                <p>🚨 태양광 발전기 불량</p>
                            </div>
                        );                                                                        
                    } else if (errorCode > 0) {
                        // 0보다 크지만, 위에 정의되지 않은 기타 에러 코드인 경우
                        popoverContent = (
                            <div>
                                <p>🚫 알 수 없는 에러 발생</p>
                                <p>* 관리자에게 문의 하세요.</p>
                            </div>
                        );
                    } else {
                        // errorCode가 0인 경우 (정상 작동)
                        popoverContent = (
                            <div>
                                <p>✅ 장치 상태 정상</p>
                            </div>
                        );
                    }
                    return (                   
                        <header className="dashboard-header">
                            <span>{selectedGroupName} {deviceNum}</span>
                            <div className={`system-status ${errorStatusClass}`}>
                                <span className="status-dot"></span>
                                {/* <span className="status-text">{errorStatusText} ( Code: {Number(device.errSts)} )</span> */}
                                <Popover content={popoverContent} title="상세정보" trigger="click">
                                    <span className="status-text">{errorStatusText} ( Code: {errorCode} )</span>
                                </Popover>                                
                            </div>
                            <hr></hr>
                        </header>
                    );
                })}
            </div>
            </>
            </DeviceStyle.MainContainer>
        </MediaQuery>

        <MediaQuery minWidth={768}>
            <DeviceStyle.MainContainer>
            <>
            <div className="dashboard-tablet-group-status-container">
                {devices.map((device, fullIndex) => {
                    const deviceNum = fullIndex + 1;
                    const errorCode = Number(device.errSts);
                    const errorStatusText = Number(device.errSts) > 0 ? '에러 발생' : '정상 작동';
                    const errorStatusClass = Number(device.errSts) > 0 ? 'status-error' : 'status-ok';
                    let popoverContent; 

                    if (errorCode === 1) {
                        popoverContent = (
                            <div>
                                <p>🚨 통신 오류</p>
                            </div>
                        );
                    } else if (errorCode === 2) {
                        popoverContent = (
                            <div>
                                <p>🚨 LED 조명 불량</p>
                            </div>
                        );
                    } else if (errorCode === 3) {
                        popoverContent = (
                            <div>
                                <p>🚨 가로등 기울기 불량</p>
                            </div>
                        );
                    } else if (errorCode === 4) {
                        popoverContent = (
                            <div>
                                <p>🚨 풍력 발정기 불량</p>
                            </div>
                        );
                    } else if (errorCode === 5) {
                        popoverContent = (
                            <div>
                                <p>🚨 태양광 발전기 불량</p>
                            </div>
                        );                                                                        
                    } else if (errorCode > 0) {
                        // 0보다 크지만, 위에 정의되지 않은 기타 에러 코드인 경우
                        popoverContent = (
                            <div>
                                <p>🚫 알 수 없는 에러 발생</p>
                                <p>* 관리자에게 문의 하세요.</p>
                            </div>
                        );
                    } else {
                        // errorCode가 0인 경우 (정상 작동)
                        popoverContent = (
                            <div>
                                <p>✅ 장치 상태 정상</p>
                            </div>
                        );
                    }
                    return (                   
                        <div className="dashboard-tablet-group-status-list" key={device.deviceNum || fullIndex} 
                            style={{ 
                                borderLeft: `15px solid ${errorCode > 0 ? '#ff4d4f' : '#52c41a'}`, // 좌측에 상태 바 강조
                            }}
                            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 16px rgba(241, 241, 241, 0.95)'}
                            onMouseLeave={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(238, 238, 238, 0.92)'}
                        >
                            <div >{selectedGroupName} {deviceNum}</div>
                            <br></br>
                            <div className={`system-status ${errorStatusClass}`}>
                                {/* <span className="status-dot"></span> */}
                                <Popover content={popoverContent} title="상세정보" trigger="click">
                                    <span className="status-text">{errorStatusText} ( Code: {errorCode} )</span>
                                </Popover>                                
                            </div>
                        </div>
                    );
                })}
                </div>
            </>
            </DeviceStyle.MainContainer>
        </MediaQuery>        
        </>


    );
};

export default GroupStatus;
